import { useEffect, useState } from "react";
import { database } from "../firebase/firebase";
import { ref, onValue } from "firebase/database";
import "../styles/main.css";

export default function DayBook(){

const [sales,setSales] = useState([]);
const [purchases,setPurchases] = useState([]);
const [salesTotal,setSalesTotal] = useState(0);
const [purchaseTotal,setPurchaseTotal] = useState(0);

useEffect(()=>{

const today = new Date().toISOString().slice(0,10);

/* SALES */

const invoiceRef = ref(database,"invoices");

onValue(invoiceRef,(snapshot)=>{

const data = snapshot.val();

if(!data){
setSales([]);
setSalesTotal(0);
return;
}

const list = Object.values(data);

const todaySales = list.filter(inv =>
inv.date && inv.date.slice(0,10) === today
);

setSales(todaySales);

let sum = 0;

todaySales.forEach(inv=>{
sum += Number(inv.total || 0);
});

setSalesTotal(sum);

});


/* PURCHASE */

const purchaseRef = ref(database,"purchases");

onValue(purchaseRef,(snapshot)=>{

const data = snapshot.val();

if(!data){
setPurchases([]);
setPurchaseTotal(0);
return;
}

const list = Object.values(data);

const todayPurchase = list.filter(p =>
p.date && p.date.slice(0,10) === today
);

setPurchases(todayPurchase);

let sum = 0;

todayPurchase.forEach(p=>{
sum += Number(p.total || 0);
});

setPurchaseTotal(sum);

});

},[]);

return(

<div className="mobile-app">

<div className="page-header">
<h2>Day Book</h2>
</div>

<div className="section">

<h3>Today's Summary</h3>

<div className="card">
<p>Sales: ₹{salesTotal}</p>
<p>Purchases: ₹{purchaseTotal}</p>
</div>

</div>

<div className="section">

<h3>Sales Transactions</h3>

{sales.map((sale,index)=>(
<div key={index} className="card">

<p><b>Customer:</b> {sale.customer}</p>
<p><b>Item:</b> {sale.item}</p>
<p><b>Total:</b> ₹{sale.total}</p>

</div>
))}

</div>

<div className="section">

<h3>Purchase Transactions</h3>

{purchases.map((p,index)=>(
<div key={index} className="card">

<p><b>Supplier:</b> {p.supplier}</p>
<p><b>Item:</b> {p.item}</p>
<p><b>Total:</b> ₹{p.total}</p>

</div>
))}

</div>

</div>

)

}